module.exports = __webpack_public_path__ + "static/media/clinicsAndHospitals.5545202b.jpg";